<template>
  <span @click="ontime_type" data-id="data-id" :class="state && bacolor?'active2':'active'" class="dot">
    <slot>&nbsp;</slot>
  </span>
</template>

<script>
    export default {
        name: "Dot",
        data(){
          return{

          }
        },
        mounted(){

        },
        props:{
          state:{
            type:Boolean,
            default:false
          },
          bacolor:{
            type:Boolean,
            default:false
          },
          tips:{
            type:String,
            default:'默认提示'
          }
        },
        methods:{
          ontime_type(e){
            this.$emit('ontime_type',e);
          }
        }
    }
</script>

<style scoped lang="less">
  @import "../../assets/less/base";
  .dot{
    /*display: inline-block;*/
    /*border-radius: 50%;*/
    /*width: 0.4rem;*/
    /*height: 0.4rem;*/
    /*background: #f2f2f2;*/
    display: inline-block;
    border-radius: 50%;
    border: 1px solid #979797;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: #fff;
    color: transparent;
    cursor: pointer;
    &.active{
      background: #f7f7f5;
      color: #535353;
    }
    &.active2{
      background: @maincolor2;
      color: #535353;
    }
  }
</style>



// WEBPACK FOOTER //
// src/assembly/Dot/Dot.vue